import type { LiveStartingSoon } from '@/types';
import { LiveSplash } from './components/LiveSplash';

// GET /:eventSlug/live/starting-soon — the same splash as /live/brb before the block
// starts.
export default function StartingSoon({ splash }: LiveStartingSoon) {
  return (
    <>
      <LiveSplash
        splash={splash}
        subtitle="Presentaciones finales"
        message="Empezamos pronto"
      />
    </>
  );
}
